module.exports = __webpack_public_path__ + "img/dark.13dd5f0e.svg";